import { IconUserCircle } from '@tabler/icons-react';
import React, { useState } from 'react';
import { Dropdown, DropdownToggle } from 'reactstrap';
import { TOP_NAV_V2_ICON_PARENT_CLASS } from 'components/NSNavBarV2/constants';
import { useTypedFlags } from 'hooks/useTypedFlags';
import UserMenuItems from './UserMenuItem/UserMenuItems';
import useGetAuthenticatedUser from '../../../../queries/UserMenu/useGetAuthenticatedUser';
import NSUserAvatar from 'bricks/NSUserAvatar/NSUserAvatar';

const V1_USER_ICON_STYLE = { fontSize: '32px', width: '32px', height: '32px' };

const UserMenu: React.FC = () => {
    const { ldFlagNavbarV2 } = useTypedFlags();
    const { data: authenticatedUser } = useGetAuthenticatedUser();

    const [isUserMenuOpen, setIsUserMenuOpen] = useState<boolean>(false);
    const toggleUserMenu = () => setIsUserMenuOpen(!isUserMenuOpen);
    const userPicture = authenticatedUser?.user.picture;

    const iconSize = ldFlagNavbarV2 ? 24 : 32;
    return (
        <Dropdown isOpen={isUserMenuOpen} toggle={toggleUserMenu} className="UserMenu-dropdown" data-testid="user-menu-dropdown">
            <DropdownToggle tag="span" data-testid="user-menu-toggle">
                <div
                    className={ldFlagNavbarV2 ? TOP_NAV_V2_ICON_PARENT_CLASS : 'd-flex align-items-center'}
                    style={{ cursor: 'pointer', ...(ldFlagNavbarV2 ? {} : V1_USER_ICON_STYLE) }}
                    aria-label="user menu"
                    data-testid="user-menu-icon"
                >
                    <NSUserAvatar
                        userPicture={userPicture}
                        customIcon={IconUserCircle}
                        backgroundColor="transparent"
                        textColor="currentColor"
                        size={iconSize}
                        shouldUseIcon
                        fullSizeIcon
                    />
                </div>
            </DropdownToggle>
            {isUserMenuOpen && <UserMenuItems authenticatedUser={authenticatedUser} />}
        </Dropdown>
    );
};

export default UserMenu;
